// src/live/types/liveRole.ts

export type LiveRole = 'host' | 'invited_participant' | 'viewer';

export interface LiveRoleInput {
  hostId: string;
  allowedUsers?: string[];
  userId?: string;
}

/**
 * Pure function — no side effects. Determines the user's role for a live entry.
 * Host              → created the room/event
 * InvitedParticipant → in allowedUsers[] (and not host)
 * Viewer            → everyone else (including unauthenticated)
 */
export function resolveLiveRole({ hostId, allowedUsers, userId }: LiveRoleInput): LiveRole {
  if (!userId) return 'viewer';
  if (userId === hostId) return 'host';
  if (allowedUsers?.includes(userId)) return 'invited_participant';
  return 'viewer';
}
